var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"swiperScroll",staticClass:"left-right-swiper-scroll-box"},[_c('div',{ref:"swiperScrollContent",staticClass:"swiper-scroll-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }